// extracted by mini-css-extract-plugin
module.exports = {"teaserLink":"_2frcIh","icon":"_32DZyt","alt":"_1ioW9e"};